// extracted by mini-css-extract-plugin
module.exports = {"cont":"Articles_cont__2_nEb"};